import React, { FunctionComponent, useRef } from 'react'
import DateSelect from './DateSelect/DateSelect'
import { parseDate, toServerDate } from '../../../utils/date-utils'
import DeadlinePanel from '../elements/DeadlinePanel/DeadlinePanel'
import styles from '../../pages/projects/ProjectPage/tasks/TaskBody/TaskBody.module.sass'
import { PERMISSIONS } from '../../../constants/permissions'
import { flow } from 'fp-ts/function'
import { useRipple } from 'react-use-ripple/dist'
import { useAllPermissions } from '../../../utils/hooks'

interface Props {
    value?: string,
    onChange: (value: string) => void,
    deadline_text?: string,
    deadline_type?: string
}

const DeadlinePicker: FunctionComponent<Props> = ({value, onChange, deadline_text, deadline_type}) => {
    const innerRef = useRef<HTMLDivElement>(null)
    useRipple(innerRef)
    const canEdit = useAllPermissions([PERMISSIONS.TASK.EDIT])

    return  <DateSelect
        value={parseDate(value)}
        disabledDays={{ before: new Date() }}
        onChange={flow(toServerDate, onChange)}
        newDeadLineDate={true}
    >
        {
            ({ toggle }) => <DeadlinePanel
                ref={innerRef}
                className={styles.deadline}
                disabled={!canEdit}
                value={value}
                onClick={toggle}
                deadline_text={deadline_text}
                deadline_type={deadline_type}
            />
        }
    </DateSelect>
}

export default DeadlinePicker